import PriceFilter from './PriceFilter.vue'

export default PriceFilter
